// ESM-Huelle fuer lib/scripts/components/CMP_CContainerTableBody.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CContainerTableBody (id)
{
    this.construct (id);

    this.name = "CContainerTableBody";
    this.htmlType = "tbody";

    this.rows = new Array ();
    this.properties = 
    {
        rows: 1,
        columns: 1
    };
}

CContainerTableBody.prototype = new CComponent;

CContainerTableBody.prototype.prepare = function ()
{
    for (var r = 0; r < this.properties.rows; r++)
    {
        this.rows[r] = this.addChild (CContainerRow);
        this.rows[r].properties.columns = this.properties.columns;
        this.rows[r].prepare ();
    }
    
    this.prepared = true;
}
export { CContainerTableBody };
